<template>
  <div>
    <v-layout row wrap>
      <v-flex md6 pr-4>
        <v-select
          v-model="filters.tranche"
          :items="trMorasList"
          color="grey">
        </v-select>
      </v-flex>
      <v-flex md6>
        <v-select
          :disabled="searching"
          v-model="filters.portfolio_type"
          :items="portfolios"
          color="grey">
        </v-select>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import reportsListMixin from '@/mixins/reportsList';
import EventBus from '@/event-bus';

export default {
  mixins: [
    reportsListMixin,
  ],
  created() {
    EventBus.$on('applyHistoricGraphicFilters', () => {
      EventBus.$emit('filterHistoricGraphic', this.filters);
    });
    EventBus.$on('openSidebar', this.getPortfolios);
    EventBus.$on('openSidebarHistoric', this.getPortfolios);
  },
  destroyed() {
    EventBus.$off('applyHistoricGraphicFilters');
    EventBus.$off('openSidebarHistoric');
  },
  data() {
    return {
      portfolios: [
        {
          text: 'Todas las carteras',
          value: '',
        },
      ],
      searching: false,
      filters: {
        tranche: '',
        portfolio_type: '',
      },
    };
  },
  methods: {
    getPortfolios(filters) {
      this.searching = true;
      this.axios.get('notification_schedules/portfolio_types', {
        params: {
          column: 'portfolio_type',
          tranche: filters.tranche,
          date: filters.from,
          type: 'month',
        },
      }).then((response) => {
        response.data.unshift({
          text: 'Todas las carteras',
          value: '',
        });
        this.portfolios = response.data;
        this.searching = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/panel/management/filters/Historic.vue